import React, { useState, useEffect } from "react";
import Container from "../components/container/Container";
import Header from "../components/navigationBars/Header";
import TracksList from "../components/navigationBars/TrackList";
import { errorHandler } from "../components/ErrorHandler";
import ApiCall from "../constants/Api";
import { helpAxios } from "../helpers/helpAxios";
import TypeMessagesRMQ from "../constants/TypeMessagesRMQ";
import MainFieldsMessageRMQ from "../constants/MainFieldsMessageRMQ";
import FieldRaceMessageRMQ from "../constants/FieldRaceMessageRMQ";
import FieldEntryMessageRMQ from "../constants/FieldEntryMessageRMQ";
import SiteConfig from "../constants/SiteConfig";
import { ErrorSessionNoLongerExists } from "../components/utilities/ErrorSessionNoLongerExists";
import ErrorCodes from "../constants/ErrorCodes";
import { useWebSocket } from "../services/WebSocketProvider";

const initialFormPlayer = {
  playerName: "",
};
const Dashboard = ({
  data,
  logout,
  dateServer,
  getTimeUTCFormat,
  getDateUTCFormat,
  getDBDateServer,
  setLoginPlayerInfo,
  loginPlayerInfo,
  setStateTracks,
  stateTracks,
  statisticsPlayer,
  setStatisticsPlayer,
  publicIP,
  setLoginInfo,
  sessionNoLongerExists,
  setSessionNoLongerExists,
  setLoginInfoUUID,
  loginInfoUUID,
}) => {
  const [loading, setLoading] = useState(false);
  const [playerLoginInit, setPlayerLoginInit] = useState(false);
  const [entriesInfo, setEntriesInfo] = useState([]);
  const [entriesPicks, setEntriesPicks] = useState([]);
  const [playerCode, setPlayerCode] = useState({});
  const [playerCodeInit, setPlayerCodeInit] = useState(false);
  const [resultsList, setResultsList] = useState([]);
  const [formPlayer, setFormPlayer] = useState(initialFormPlayer);
  const [config, setConfig] = useState(window.config.RMQConfig.Active);
  const [processedEntries, setProcessedEntries] = useState([]);
  const [openTracks, setOpenTracks] = useState([]);

  const {
    lastMessagePublisher,
    setLastMessagePublisher,
    entriesMessageRMQ,
    setEntriesMessageRMQ,
    raceCreateMessageRMQ,
    setRaceCreateMessageRMQ,
    entryCreateMessageRMQ,
    setEntryCreateMessageRMQ,
    lastMessage,
    setLastMessage,
    selectOption,
    setSelectOption,
  } = useWebSocket();

  // Function to obtain the date from the server
  function formatDate(dateTimeString) {
    const parts = dateTimeString.split(" ");
    if (parts.length >= 1) {
      const fechaParte = parts[0];
      const [day, month, year] = fechaParte.split("/");
      return `${year}-${month}-${day}`;
    }
    return "Invalid Format";
  }

  useEffect(() => {
    if (sessionNoLongerExists) {
      ErrorSessionNoLongerExists(localStorage.getItem("userName"));
      setLoginInfo({ LogonSessionID: "" });
      setLoginInfoUUID("");
      setLoginPlayerInfo({ IdPlayer: 0 });
      if (setFormPlayer) {
        setFormPlayer("");
      }
      setStateTracks({
        thoroughbredList: [],
        harnessList: [],
        greyList: [],
        trackList: [],
      });
      setSelectOption({
        trackID: 0,
        trackName: "",
        raceID: 0,
        raceNumber: 0,
        trackCode: "",
        raceStatus: "",
      });
      setPlayerLoginInit(false);
      localStorage.setItem("playerName", "");
      localStorage.setItem("loginPlayerInfo", "{}");
      localStorage.setItem("TracksInfo", "{}");
      localStorage.removeItem("openBets");
      setSessionNoLongerExists(false);
      const modalBackdrop = document.querySelector(".modal-backdrop");
      if (modalBackdrop) {
        modalBackdrop.parentNode.removeChild(modalBackdrop);
      }
    }
  }, [sessionNoLongerExists]);

  function convertDate(date) {
    const format = date.split("-");
    if (format.length === 3) {
      const dateConvert = `${format[0]}-${format[2]}-${format[1]}`;
      return dateConvert;
    } else {
      return "Invalid Format";
    }
  }

  useEffect(() => {
    if (lastMessagePublisher.length !== 0 && loginPlayerInfo.IdPlayer !== 0) {
      const processMP = async () => {
        const messagePublisherRMQ = [...lastMessagePublisher];
        const processedIndexes = [];
        let hasProcessedAny = false;

        while (messagePublisherRMQ.length > 0) {
          const dataMP = messagePublisherRMQ[0];
          let processDate = getDateUTCFormat(dataMP.LastModification);
          let systemDate = dateServer;

          if (processDate === systemDate) {
            setStatisticsPlayer((prevStatistics) => {
              const newStatistics = { ...prevStatistics };
              Object.keys(dataMP).forEach((key) => {
                if (newStatistics.hasOwnProperty(key)) {
                  newStatistics[key] = dataMP[key];
                }
              });
              return newStatistics;
            });

            processedIndexes.push(lastMessagePublisher.indexOf(dataMP));
            messagePublisherRMQ.shift();
            hasProcessedAny = true;
          } else {
            break;
          }
        }

        if (hasProcessedAny) {
          setLastMessagePublisher((prevMP) =>
            prevMP.filter((_, index) => !processedIndexes.includes(index)),
          );
        }
      };

      processMP();
    }
  }, [lastMessagePublisher]);

  useEffect(() => {
    if (config) {
      if (lastMessage.ProcessDateTime) {
        let processDate = formatDate(lastMessage.ProcessDateTime);
        let systemDate = convertDate(dateServer);

        if (processDate === systemDate) {
          switch (lastMessage.MessageType) {
            case TypeMessagesRMQ.RaceChange.name:
              if (lastMessage.Changes) {
                lastMessage.Changes.forEach((change, i) => {
                  //Changes in TrackList
                  if (stateTracks.trackList) {
                    const updatedTrackList = stateTracks.trackList.map(
                      (track) => {
                        // Change MTP in TrackList
                        if (change.Field === MainFieldsMessageRMQ.MTP.name) {
                          if (parseInt(change.NewValue) >= 0) {
                            if (track.Races) {
                              track.Races.forEach((raceT, i) => {
                                if (raceT.RaceID === lastMessage.RaceID) {
                                  raceT.MTP = parseInt(change.NewValue);
                                }
                              });
                            }
                          } else {
                            if (track.Races) {
                              track.Races.forEach((raceT, i) => {
                                if (raceT.RaceID === lastMessage.RaceID) {
                                  raceT.MTP = -128;
                                }
                              });
                            }
                          }
                        }

                        //Change Race Info Details
                        if (selectOption.raceID) {
                          if (selectOption.raceID === lastMessage.RaceID) {
                            let newValue;
                            FieldRaceMessageRMQ.forEach((element) => {
                              if (
                                element.name === change.Field &&
                                newValue !== ""
                              ) {
                                if (element.type === "bool") {
                                  newValue = JSON.parse(change.NewValue);
                                } else if (element.type === "int") {
                                  newValue = parseInt(change.NewValue);
                                } else {
                                  newValue = change.NewValue;
                                }

                                if (track.Races) {
                                  track.Races.forEach((raceT) => {
                                    if (raceT.RaceID === lastMessage.RaceID) {
                                      raceT[element.name] = newValue;
                                    }
                                  });
                                }
                              }
                            });
                          }
                        }

                        //Change Field RaceStatus
                        if (
                          change.Field === MainFieldsMessageRMQ.RaceStatus.name
                        ) {
                          if (track.TrackID === lastMessage.TrackID) {
                            if (track.Races) {
                              track.Races.forEach((raceT, i) => {
                                if (raceT.RaceID === lastMessage.RaceID) {
                                  raceT.RaceStatus = change.NewValue;
                                }
                              });
                            }
                          }
                        }

                        //Change Track Complete
                        //Change UpcomingRace in Track
                        if (
                          change.Field ===
                            MainFieldsMessageRMQ.RaceStatus.name &&
                          track.TrackID === lastMessage.TrackID
                        ) {
                          const updatedUpcomingRace = {
                            RaceID: lastMessage.UpComingRaceID,
                            RaceStatus: lastMessage.UpComingRaceStatus,
                            RaceNumber: lastMessage.UpComingRaceNum,
                          };
                          let trackComplete = false;
                          if (change.NewValue === "C") {
                            if (track.TrackID === lastMessage.TrackID) {
                              if (lastMessage.RaceNumber === track.TotalRaces) {
                                trackComplete = true;
                                updatedUpcomingRace.RaceID = 0;
                                updatedUpcomingRace.RaceStatus = "";
                                updatedUpcomingRace.RaceNumber = 0;
                              } else {
                                trackComplete = false;
                              }
                            }
                          } else if (change.NewValue === "B") {
                            if (lastMessage.RaceNumber === track.TotalRaces) {
                              updatedUpcomingRace.RaceID = 0;
                              updatedUpcomingRace.RaceStatus = "";
                              updatedUpcomingRace.RaceNumber = 0;
                            }
                          }

                          return {
                            ...track,
                            UpcomingRace: updatedUpcomingRace,
                            Complete: trackComplete,
                          };
                        }

                        return track;
                      },
                    );

                    setStateTracks({
                      ...stateTracks,
                      trackList: updatedTrackList,
                    });

                    let thoroughbredListResp = [],
                      harnessListResp = [],
                      greyListResp = [],
                      trackListResp = [];

                    if (updatedTrackList) {
                      updatedTrackList.forEach((track) => {
                        trackListResp.push(track);
                        switch (track.TrackType) {
                          case 0:
                            thoroughbredListResp.push(track);
                            break;
                          case 1:
                            harnessListResp.push(track);
                            break;
                          case 2:
                            greyListResp.push(track);
                            break;
                          default:
                            return;
                        }
                      });
                    }
                    setStateTracks({
                      trackList: updatedTrackList,
                      thoroughbredList: thoroughbredListResp,
                      harnessList: harnessListResp,
                      greyList: greyListResp,
                    });
                  }
                });
              }
              setLastMessage({
                MessageType: "",
                Message: "No message received yet",
              });
              break;
            case TypeMessagesRMQ.ResultCreate.name:
              if (
                selectOption.raceID === lastMessage.RaceID &&
                selectOption.raceStatus === "C"
              ) {
                setResultsList(lastMessage.Object);
              }
              break;
            default:
              break;
          }
        }
      }
    }
  }, [config, lastMessage, stateTracks, entriesInfo]);

  // Processes messages received from RMQ for the entry-change
  useEffect(() => {
    if (config && entriesMessageRMQ.length !== 0 && selectOption.raceID) {
      const processEntries = async () => {
        const updatedEntriesMessageRMQ = [...entriesMessageRMQ];
        while (updatedEntriesMessageRMQ.length > 0) {
          const dataEntries = updatedEntriesMessageRMQ[0];
          const processDate = formatDate(dataEntries.ProcessDateTime);
          let dateTracks = convertDate(dateServer);

          if (processDate === dateTracks) {
            for (const change of dataEntries.Changes) {
              FieldEntryMessageRMQ.forEach((element) => {
                if (element.name === change.Field) {
                  let newValue;
                  if (element.type === "bool") {
                    newValue = JSON.parse(change.NewValue);
                  } else if (element.type === "int") {
                    newValue = parseInt(change.NewValue);
                  } else {
                    newValue = change.NewValue;
                  }

                  // Updates the 'entries' status according to the criteria mentioned above.
                  setEntriesInfo((prevEntries) => {
                    const updatedEntries = [...prevEntries];
                    const entryToUpdate = updatedEntries.find(
                      (entry) => entry.EntryID === dataEntries.EntryID,
                    );
                    if (entryToUpdate) {
                      entryToUpdate[element.name] = newValue;
                    }
                    return updatedEntries;
                  });
                }
              });
            }

            // Adds the processed item to the status of processed items
            setProcessedEntries((prevProcessedEntries) => [
              ...prevProcessedEntries,
              dataEntries.EntryID,
            ]);

            // Deletes the processed item from the list
            updatedEntriesMessageRMQ.shift();
          }
        }
      };

      processEntries();
    }
  }, [config, entriesMessageRMQ, selectOption.raceID]);

  // Processes messages received from RMQ for the race-create
  useEffect(() => {
    if (config && raceCreateMessageRMQ.length) {
      const processRaces = async () => {
        const updatedRacesMessageRMQ = [...raceCreateMessageRMQ];

        const processedTracks = [];

        updatedRacesMessageRMQ.forEach((dataRaces) => {
          const processDate = formatDate(dataRaces.ProcessDateTime);
          let systemDate = convertDate(dateServer);

          if (processDate === systemDate && stateTracks.trackList) {
            stateTracks.trackList.forEach((track) => {
              if (track.TrackID === dataRaces.TrackID) {
                let newElement = {
                  Class: dataRaces.Object.Class,
                  DailyDouble: dataRaces.Object.DailyDouble,
                  Distance: dataRaces.Object.Distance,
                  Exacta: dataRaces.Object.Exacta,
                  GrandSlam: dataRaces.Object.GrandSlam,
                  High5: dataRaces.Object.High5,
                  HouseQ: dataRaces.Object.HouseQ,
                  MTP: dataRaces.Object.MTP,
                  Omni: dataRaces.Object.Omni,
                  Pick3: dataRaces.Object.Pick3,
                  Pick4: dataRaces.Object.Pick4,
                  Pick5: dataRaces.Object.Pick5,
                  Pick6: dataRaces.Object.Pick6,
                  Pick7: dataRaces.Object.Pick7,
                  Pick8: dataRaces.Object.Pick8,
                  Pick9: dataRaces.Object.Pick9,
                  Pick10: dataRaces.Object.Pick10,
                  Pick11: dataRaces.Object.Pick11,
                  Pick12: dataRaces.Object.Pick12,
                  Place: dataRaces.Object.Place,
                  PostTime: dataRaces.Object.PostTime,
                  Purse: dataRaces.Object.Purse,
                  Quinella: dataRaces.Object.Quinella,
                  RaceDate: dataRaces.Object.RaceDate,
                  RaceDesc: dataRaces.Object.RaceDesc,
                  RaceDescription: dataRaces.Object.RaceDescription,
                  RaceID: dataRaces.Object.RaceID,
                  RaceNumber: dataRaces.Object.RaceNumber,
                  RaceShortDesc: dataRaces.Object.RaceShortDesc,
                  RaceStatus: dataRaces.Object.RaceStatus,
                  Show: dataRaces.Object.Show,
                  StakeGrade: dataRaces.Object.StakeGrade,
                  StakeName: dataRaces.Object.StakeName,
                  Superfecta: dataRaces.Object.Superfecta,
                  Surface: dataRaces.Object.Surface,
                  SystemRaceDateTime: dataRaces.Object.SystemRaceDateTime,
                  TrackCond: dataRaces.Object.TrackCond,
                  Trifecta: dataRaces.Object.Trifecta,
                  Win: dataRaces.Object.Win,
                };

                if (track.Show && track.Races) {
                  track.Races.push(newElement);
                }
              }
            });

            processedTracks.push(dataRaces.RaceID);
          }
        });

        // Elimina los elementos procesados de la lista
        setRaceCreateMessageRMQ((prevRaces) =>
          prevRaces.filter((race) => !processedTracks.includes(race.RaceID)),
        );
      };

      processRaces();
    }
  }, [config, raceCreateMessageRMQ, selectOption.trackID]);

  // Processes messages received from RMQ for the entry-create
  useEffect(() => {
    if (config && entryCreateMessageRMQ.length !== 0 && selectOption.raceID) {
      const processEntriesCreate = async () => {
        const createEntryMessageRMQ = [...entryCreateMessageRMQ];
        const processedEntry = [];
        createEntryMessageRMQ.forEach((dataEntry) => {
          const processDate = formatDate(dataEntry.ProcessDateTime);
          let dateTracks = convertDate(dateServer);

          if (
            processDate === dateTracks &&
            selectOption.raceID === dataEntry.RaceID
          ) {
            const newEntry = {
              ...dataEntry.Object,
              HorseStatistics: undefined,
            };

            entriesInfo.push(newEntry);
            setEntriesInfo(entriesInfo);
            processedEntry.push(newEntry.EntryID);
          }
        });
        // Deletes the processed item from the list
        setEntryCreateMessageRMQ((prevEntry) =>
          prevEntry.filter(
            (entry) => !processedEntry.includes(entry.Object.EntryID),
          ),
        );
      };
      processEntriesCreate();
    }
  }, [config, entryCreateMessageRMQ, selectOption.raceID]);

  // Clears processed entriesMessageRMQ elements
  useEffect(() => {
    setEntriesMessageRMQ((prevEntries) =>
      prevEntries.filter((entry) => !processedEntries.includes(entry.EntryID)),
    );
  }, [processedEntries]);

  //Función para consumir el método de LOGOUT PLAYER
  const playerLogout = (setFormPlayer) => {
    const fetchData = async () => {
      const res = await helpAxios(
        SiteConfig.ACCOUNT_MGMT_SVC,
        ApiCall.LOGOUT_PLAYER,
        {
          IdPlayer: loginPlayerInfo.IdPlayer,
          IP: publicIP,
          IdCall: loginPlayerInfo.IdCall,
        },
        data.Session,
      );

      if (res.error) {
        let errorDet;
        if (res.errorDetails) {
          errorDet = res.errorDetails;
        }
        if (
          res.Result === ErrorCodes.InvalidSession ||
          res.Result === ErrorCodes.SessionNoLongerExists
        ) {
          setSessionNoLongerExists(true);
        } else {
          errorHandler(res.error, errorDet);
        }
      } else {
        setLoginPlayerInfo({ IdPlayer: 0 });
        if (setFormPlayer) {
          setFormPlayer("");
        }
        setStateTracks({
          thoroughbredList: [],
          harnessList: [],
          greyList: [],
          trackList: [],
        });
        setSelectOption({
          trackID: 0,
          trackName: "",
          raceID: 0,
          raceNumber: 0,
          trackCode: "",
          raceStatus: "",
        });
        setPlayerLoginInit(false);
        localStorage.setItem("playerName", "");
        localStorage.setItem("loginPlayerInfo", "{}");
        localStorage.setItem("TracksInfo", "{}");
        localStorage.removeItem("openBets");

        setPlayerLoginInit(false);
      }
    };

    fetchData();
  };

  const setOptions = (
    track,
    trackName,
    race,
    raceNumber,
    trackCode,
    raceStatus,
    statusTrackCollapsed,
  ) => {
    setSelectOption({
      trackID: track,
      trackName: trackName,
      raceID: race,
      raceNumber: raceNumber,
      trackCode: trackCode,
      raceStatus: raceStatus,
      statusTrackCollapsed: statusTrackCollapsed,
    });
  };

  useEffect(() => {
    if (data.Session !== "" && loginInfoUUID !== "") {
      getDBDateServer(false);
    }
  }, [data.Session]);

  //*****LOGIN Y LOGOUT DE PLAYER******
  //Función para obtener el Player Login Code
  const getCodePlayerLogin = (formPlayer) => {
    const fetchData = async () => {
      const { playerName } = formPlayer;

      const res = await helpAxios(
        SiteConfig.ACCOUNT_MGMT_SVC,
        ApiCall.GET_CODE_PLAYER_LOGIN,
        {
          LogonSessionID: data.LogonSessionID,
          Account: playerName,
        },
        data.Session,
      );

      if (res.error) {
        let errorDet;
        if (res.errorDetails) {
          errorDet = res.errorDetails;
        }
        if (
          res.Result === ErrorCodes.InvalidSession ||
          res.Result === ErrorCodes.SessionNoLongerExists
        ) {
          setSessionNoLongerExists(true);
        } else {
          errorHandler(res.error, errorDet);
        }
      } else {
        setPlayerCode({
          ...res,
          PlayerName: playerName,
        });
        setPlayerCodeInit(true);
      }
    };

    fetchData();
    setPlayerCodeInit(false);
  };

  //Function to consume the LOGIN PLAYER method
  useEffect(() => {
    if (playerCodeInit) {
      const fetchData = async () => {
        const res = await helpAxios(
          SiteConfig.ACCOUNT_MGMT_SVC,
          ApiCall.LOGIN_PLAYER,
          {
            Account: playerCode.PlayerName,
            Password: playerCode.Code,
            IP: publicIP,
            DeviceID: SiteConfig.DEVICE_ID,
            LogonSessionID: data.LogonSessionID,
            SystemID: SiteConfig.SYSTEM_ID,
          },
          data.Session,
        );

        if (res.error) {
          let errorDet;
          if (res.errorDetails) {
            errorDet = res.errorDetails;
          }

          if (
            res.Result === ErrorCodes.InvalidSession ||
            res.Result === ErrorCodes.SessionNoLongerExists
          ) {
            setSessionNoLongerExists(true);
          } else {
            errorHandler(res.error, errorDet);
          }
        } else {
          setLoginPlayerInfo({
            ...res.oPlayerLogin,
            PlayerName: playerCode.playerName,
            IdUser: data.IdUser,
            SystemDate: dateServer,
            ProfileName: res.oPlayerAddInfo.ProfileName,
          });
          localStorage.setItem("playerName", playerCode.PlayerName);
          setPlayerLoginInit(true);
        }
      };

      fetchData();
    }
  }, [playerCode]);

  //Función para cargar la info del Player (Statistics)
  const getStatistics = () => {
    const fetchData = async () => {
      const res = await helpAxios(
        SiteConfig.ACCOUNT_MGMT_SVC,
        ApiCall.GET_STATISTICS,
        {
          IdCall: loginPlayerInfo.IdCall,
          PhoneLine: SiteConfig.LOGIN_PHONE_LINE,
          IP: publicIP,
          IdPlayer: loginPlayerInfo.IdPlayer,
        },
        data.Session,
      );

      if (res.error) {
        let errorDet;
        if (res.errorDetails) {
          errorDet = res.errorDetails;
        }
        if (
          res.Result === ErrorCodes.InvalidSession ||
          res.Result === ErrorCodes.SessionNoLongerExists
        ) {
          setSessionNoLongerExists(true);
        } else {
          errorHandler(res.error, errorDet);
        }
      } else {
        setStatisticsPlayer(res.oPlayerStatistic);
      }
    };

    fetchData();
  };

  //Función para cargar los TRACKS
  const getTracks = () => {
    setStateTracks({
      thoroughbredList: [],
      harnessList: [],
      greyList: [],
      trackList: [],
    });

    const fetchData = async () => {
      setLoading(true);

      const res = await helpAxios(
        SiteConfig.RACING_SCHEDULE_SVC,
        ApiCall.GET_TRACKS,
        {
          IDPlayer: loginPlayerInfo.IdPlayer,
          RaceDate: dateServer,
          SystemID: SiteConfig.SYSTEM_ID,
          IDCall: loginPlayerInfo.IdCall,
        },
        data.Session,
      );

      if (res.error) {
        let errorDet;
        if (res.errorDetails) {
          errorDet = res.errorDetails;
        }

        if (
          res.Result === ErrorCodes.InvalidSession ||
          res.Result === ErrorCodes.SessionNoLongerExists
        ) {
          setSessionNoLongerExists(true);
        } else {
          errorHandler(res.error, errorDet);
        }
      } else {
        setStateTracks({
          ...stateTracks,
          trackList: res.TrackList,
        });

        getDBDateServer(true);
      }
      setLoading(false);
    };

    fetchData();

    setSelectOption({
      trackID: 0,
      trackName: "",
      raceID: 0,
      raceNumber: 0,
      trackCode: "",
      raceStatus: "",
    });
  };

  useEffect(() => {
    if (playerLoginInit === true) {
      if (loginPlayerInfo.IdPlayer !== 0) {
        if (loginPlayerInfo.IdCall) {
          getStatistics();
          getTracks();
        }
      } else {
        setStateTracks({
          thoroughbredList: [],
          harnessList: [],
          greyList: [],
          trackList: [],
        });
      }
    }
  }, [loginPlayerInfo]);

  useEffect(() => {
    // if (changeTracks) {
    let thoroughbredListResp = [],
      harnessListResp = [],
      greyListResp = [];

    if (stateTracks.trackList) {
      stateTracks.trackList.forEach((track) => {
        switch (track.TrackType) {
          case 0:
            thoroughbredListResp.push(track);
            break;
          case 1:
            harnessListResp.push(track);
            break;
          case 2:
            greyListResp.push(track);
            break;
          default:
            return;
        }
      });
    }

    setStateTracks({
      ...stateTracks,
      thoroughbredList: thoroughbredListResp,
      harnessList: harnessListResp,
      greyList: greyListResp,
    });
    // }
  }, [stateTracks.trackList]);

  useEffect(() => {
    //With selectOption.status the trackID is set in openTracks or deleted.
    if (selectOption.statusTrackCollapsed === "open") {
      setOpenTracks([selectOption.trackID]);
      // getStake();
    } else {
      setOpenTracks([]);
    }
  }, [selectOption]);

  //Función para cargar las Races del Track
  const getRacesTrack = (TrackID, RaceID, status, raceStatus) => {
    //Llama la función solo al momento de abrir el trackbar
    if (status === "open") {
      const fetchData = async () => {
        const res = await helpAxios(
          SiteConfig.RACING_SCHEDULE_SVC,
          ApiCall.GET_RACES,
          {
            IDPlayer: loginPlayerInfo.IdPlayer,
            ProfileID: loginPlayerInfo.IdProfile,
            RaceDate: dateServer,
            IDCall: loginPlayerInfo.IdCall,
            TrackID: TrackID,
            SystemID: SiteConfig.SYSTEM_ID,
          },
          data.Session,
        );

        if (res.error) {
          let errorDet;
          if (res.errorDetails) {
            errorDet = res.errorDetails;
          }
          if (
            res.Result === ErrorCodes.InvalidSession ||
            res.Result === ErrorCodes.SessionNoLongerExists
          ) {
            setSessionNoLongerExists(true);
          } else {
            errorHandler(res.error, errorDet);
          }
        } else {
          stateTracks.trackList.forEach((item) => {
            if (item.TrackID === TrackID) {
              //MODIFICACIÓN DE ESTADO
              item.Races = res.Races;
              item.Show = true;
            }
          });
          setStateTracks(stateTracks);
          if (RaceID !== 0) {
            getEntriesRace(RaceID, 0, raceStatus);
          }
        }
      };

      fetchData();
    } else {
      stateTracks.trackList.forEach((item) => {
        if (item.TrackID === TrackID) {
          //MODIFICACIÓN DE ESTADO
          item.Show = false;
        }
      });
      setStateTracks(stateTracks);
      if (RaceID !== 0) {
        getEntriesRace(RaceID, 0);
      }
    }
  };

  //Función para cargar los Entries del Race
  const getEntriesRace = (RaceID, pick, raceStatus) => {
    const fetchData = async (raceidPick, raceNum) => {
      let RaceIdRequest;
      if (pick !== 0) {
        RaceIdRequest = raceidPick;
      } else {
        RaceIdRequest = RaceID;
      }

      const res = await helpAxios(
        SiteConfig.RACING_SCHEDULE_SVC,
        ApiCall.GET_ENTRIES,
        {
          IDPlayer: loginPlayerInfo.IdPlayer,
          IDCall: loginPlayerInfo.IdCall,
          SystemID: SiteConfig.SYSTEM_ID,
          RaceID: RaceIdRequest,
        },
        data.Session,
      );

      if (res.error) {
        let errorDet;
        if (res.errorDetails) {
          errorDet = res.errorDetails;
        }
        if (
          res.Result === ErrorCodes.InvalidSession ||
          res.Result === ErrorCodes.SessionNoLongerExists
        ) {
          setSessionNoLongerExists(true);
        } else {
          errorHandler(res.error, errorDet);
        }
      } else {
        if (pick !== 0) {
          res.EntryList.forEach((element) => {
            element.RaceNumber = raceNum;
          });
          //se llena cuando el wt requiere más de una carrera
          setEntriesPicks((entriesPicks) => [...entriesPicks, res.EntryList]);
        } else {
          //se llena cuando el wt requiere una carrera
          setEntriesInfo([]);
          setEntriesInfo(res.EntryList);
        }
        if (raceStatus === "C") {
          getResults(RaceID);
        }
      }
    };
    if (pick !== 0) {
      setEntriesPicks([]);
      let findFirstRace = false,
        nextRaces = 0;
      stateTracks.trackList
        .filter((item) => item.TrackID === selectOption.trackID)[0]
        .Races.forEach((element) => {
          if (element.RaceID === selectOption.raceID || findFirstRace) {
            findFirstRace = true;
            if (nextRaces >= pick) {
              findFirstRace = false;
            }

            if (findFirstRace) {
              fetchData(element.RaceID, element.RaceNumber);
            }

            nextRaces++;
          }
        });
    } else {
      fetchData();
    }
  };

  //Get Results Info for Races in Complete status
  const getResults = (RaceID) => {
    const fetchData = async () => {
      const res = await helpAxios(
        SiteConfig.RACING_SCHEDULE_SVC,
        ApiCall.GET_RESULTS,
        {
          IDPlayer: loginPlayerInfo.IdPlayer,
          IDCall: loginPlayerInfo.IdCall,
          SystemID: SiteConfig.SYSTEM_ID,
          RaceID: RaceID,
        },
        data.Session,
      );

      if (res.error) {
        let errorDet;
        if (res.errorDetails) {
          errorDet = res.errorDetails;
        }
        if (
          res.Result === ErrorCodes.InvalidSession ||
          res.Result === ErrorCodes.SessionNoLongerExists
        ) {
          setSessionNoLongerExists(true);
        } else {
          errorHandler(res.error, errorDet);
        }
      } else {
        if (!res.WPSList) {
          res.WPSList = [
            {
              pos: 1,
              entryname: "",
              entrynum: "",
              win: "",
              place: "",
              show: "",
              new: true,
            },
            {
              pos: 2,
              entryname: "",
              entrynum: "",
              win: "",
              place: "",
              show: "",
              new: true,
            },
            {
              pos: 3,
              entryname: "",
              entrynum: "",
              win: "",
              place: "",
              show: "",
              new: true,
            },
          ];
        }

        setResultsList(res);
      }
    };

    fetchData();
  };

  //GET WAGER GUID

  const getWagerGUID = async () => {
    let res;

    res = await helpAxios(
      SiteConfig.RACING_TICKET_VALIDATOR_SVC,
      ApiCall.GET_WAGER_GUID,
      {},
      data.Session,
    );

    if (res.Result !== 0) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      } else {
        errorHandler(res.ErrMsg);
      }
    } else {
      return res.WagerGUID;
    }
  };

  return (
    <>
      <Header
        logout={logout}
        playerLogout={playerLogout}
        getCodePlayerLogin={getCodePlayerLogin}
        loginPlayerInfo={loginPlayerInfo}
        statisticsPlayer={statisticsPlayer}
        getTimeUTCFormat={getTimeUTCFormat}
        getDateUTCFormat={getDateUTCFormat}
        formPlayer={formPlayer}
        setFormPlayer={setFormPlayer}
        getStatistics={getStatistics}
        playerCode={playerCode}
        session={data.Session}
        publicIP={publicIP}
        setSessionNoLongerExists={setSessionNoLongerExists}
      />

      <TracksList
        selectOption={selectOption}
        setSelectOption={setOptions}
        stateTracks={stateTracks}
        loading={loading}
        getTracks={getTracks}
        getRacesTrack={getRacesTrack}
        getEntriesRace={getEntriesRace}
        openTracks={openTracks}
        setOpenTracks={setOpenTracks}
      />

      {loginPlayerInfo.IdPlayer !== 0 &&
        selectOption.raceID !== 0 &&
        selectOption.trackID !== 0 && (
          <div className="pcoded-main-container">
            <div className="pcoded-wrapper">
              <div className="pcoded-content">
                <div className="pcoded-inner-content">
                  <div className="main-body">
                    <div className="page-wrapper">
                      <div className="row">
                        {stateTracks.trackList.filter(
                          (item) => item.TrackID === selectOption.trackID,
                        )[0].Races && (
                          <Container
                            trackInfo={
                              stateTracks.trackList.filter(
                                (item) => item.TrackID === selectOption.trackID,
                              )[0]
                            }
                            raceID={selectOption.raceID}
                            entriesInfo={entriesInfo}
                            loginPlayerInfo={loginPlayerInfo}
                            resultsList={resultsList}
                            getEntriesRace={getEntriesRace}
                            entriesPicks={entriesPicks}
                            getStatistics={getStatistics}
                            session={data.Session}
                            setSessionNoLongerExists={setSessionNoLongerExists}
                            getWagerGUID={getWagerGUID}
                            publicIP={publicIP}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default Dashboard;
